import React from "react"

import { NavigationHeaderDesktopMain } from "./Main/NavigationHeaderDesktopMain"

export const NavigationHeaderDesktop = ({ desktopNavigationFormat, location,  scrolling, isSolid }) => (
    <NavigationHeaderDesktopMain isSolid={isSolid} desktopNavigationFormat={desktopNavigationFormat} location={location} scrolling={scrolling} />
)
